import { Image, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import AmenityPropType from '../../prop-types/amenity';
import styles from './Amenity.module.css';

const cx = classnames.bind(styles);

export default function Amenity({ item, compact }) {
  return (
    <div className={cx('amenityItem', { compact })}>
      <Image
        className={cx('amenityIcon', { compact })}
        src={item.imageURL}
        alt={item.displayName}
      />
      <Text>{item.displayName}</Text>
    </div>
  );
}

Amenity.propTypes = {
  item: AmenityPropType.isRequired,
  compact: PropTypes.bool,
};

Amenity.defaultProps = {
  compact: false,
};

Amenity.displayName = 'AmenityItem';
